// extracted by mini-css-extract-plugin
module.exports = {"welcomeinfo":"WelcomeInfo_welcomeinfo__1_nqo","contactinfo":"WelcomeInfo_contactinfo__14m2m","icon":"WelcomeInfo_icon__2vSY5"};